import React from "react";
import { useNavigate } from "react-router-dom";
import { LogOut, Menu, Settings } from "lucide-react";
import { getStoredAdmin } from "../utils/adminAuth";

function AdminTopbar({ isMobile = false, isLaptop = false, onMenuClick = () => {} }) {
  const navigate = useNavigate();
  const admin = getStoredAdmin();

  const handleLogout = () => {
    localStorage.removeItem("admin");
    navigate("/admin-login");
  };

  return (
    <header style={isMobile ? mobileBar : isLaptop ? laptopBar : bar}>
      <div style={left}>
        {isMobile && (
          <button type="button" style={menuBtn} onClick={onMenuClick}>
            <Menu size={18} color="#f97316" />
          </button>
        )}
        <div style={avatarBox}>
          {String(admin?.name || admin?.email || "A").trim().charAt(0).toUpperCase()}
        </div>
        <div style={nameBlock}>
          <span style={nameText}>{admin?.name || admin?.email || "Admin"}</span>
          {!isMobile && (
            <span style={roleText}>{admin?.role === "sub_admin" ? "Sub Admin" : "Super Admin"}</span>
          )}
        </div>
      </div>

      <div style={right}>
        <button type="button" style={settingsBtn} onClick={() => navigate("/admin/settings")} title="Settings">
          <Settings size={16} />
          {!isMobile && <span>Settings</span>}
        </button>
        <button type="button" style={logoutBtn} onClick={handleLogout} title="Logout">
          <LogOut size={16} />
          {!isMobile && <span>Logout</span>}
        </button>
      </div>
    </header>
  );
}

const base = {
  height: "64px",
  background: "#fff",
  borderBottom: "1px solid #e5e7eb",
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  padding: "0 20px",
  boxSizing: "border-box",
  position: "sticky",
  top: 0,
  zIndex: 10,
  boxShadow: "0 1px 8px rgba(0,0,0,0.06)",
};
const bar = base;
const laptopBar = { ...base, height: "58px", padding: "0 14px" };
const mobileBar = { ...base, height: "56px", padding: "0 12px" };

const left = { display: "flex", alignItems: "center", gap: 12 };
const menuBtn = { width: 36, height: 36, border: "1px solid #e5e7eb", background: "#f8fafc", borderRadius: 10, display: "grid", placeItems: "center", cursor: "pointer" };
const avatarBox = { width: 36, height: 36, borderRadius: 10, background: "linear-gradient(135deg, #f97316, #ea580c)", color: "#fff", fontWeight: 900, fontSize: 15, display: "grid", placeItems: "center", flexShrink: 0 };
const nameBlock = { display: "flex", flexDirection: "column", gap: 1 };
const nameText = { color: "#111827", fontSize: 14, fontWeight: 700, lineHeight: 1.2 };
const roleText = { color: "#6b7280", fontSize: 11, fontWeight: 600 };

const right = { display: "flex", alignItems: "center", gap: 8 };
const settingsBtn = { height: 38, padding: "0 14px", border: "1px solid #e5e7eb", background: "#f8fafc", color: "#374151", borderRadius: 10, display: "flex", alignItems: "center", gap: 7, fontSize: 13, fontWeight: 600, cursor: "pointer" };
const logoutBtn = { height: 38, padding: "0 14px", border: "1px solid #fecaca", background: "#fff5f5", color: "#dc2626", borderRadius: 10, display: "flex", alignItems: "center", gap: 7, fontSize: 13, fontWeight: 600, cursor: "pointer" };

export default AdminTopbar;
